import e,{Component as o}from"react";import i,{keyframes as n,css as t}from"styled-components";import r from"prop-types";import{calculateRem as s}from"@vds-core/utilities";import d from"@uie/set-env-ref";const a={children:r.node,disableOutsideClick:r.bool,onDismiss:r.func.isRequired,modalOpened:r.bool.isRequired,opened:r.bool.isRequired,fullScreenDialog:r.bool,surface:r.string},l=n`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`,p=n`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`,c=i.div.withConfig({displayName:"Overlay",componentId:"VDS__sc-1jlpnbt-0"})`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({fullScreenDialog:e,viewport:o,surface:i})=>e||"mobile"===o?"transparent":"dark"===i?"rgba(255, 255, 255, 0.8)":"rgba(0, 0, 0, 0.8)"};
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  padding: ${({fullScreenDialog:e,viewport:o})=>e||"mobile"===o?"0":s(16)};

  @media (max-width: 767px) {
    padding: 0;
  }

  ${({modalOpened:e,opened:o})=>(e||o)&&t`
      animation: ${l} 0.4s
        cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
    `};

  ${({unmounted:e})=>e&&t`
      animation: ${p} 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
    `};
`;class m extends o{constructor(){super(...arguments),this.handleDown=e=>{27===e.keyCode&&this.props.onDismiss()},this.onClick=e=>{this.props.disableOutsideClick||e.target.contains(this.overlayRef)&&this.props.onDismiss()},this.refPath=d()}componentDidMount(){"undefined"!=typeof document&&document.addEventListener("keydown",this.handleDown)}componentWillUnmount(){"undefined"!=typeof document&&document.removeEventListener("keydown",this.handleDown)}render(){const{children:o,fullScreenDialog:i,noMobilePadding:n,viewport:t,unmounted:r,modalOpened:s,surface:d}=this.props;return e.createElement(c,Object.assign({unmounted:r,modalOpened:s,fullScreenDialog:i,onMouseDown:this.onClick,noMobilePadding:n,viewport:t},{[this.refPath]:e=>this.overlayRef=e},{surface:d}),o)}}m.propTypes=a;export{m as default};
